<div class="sidebar-overlay"></div>
<aside class="left-sidebar" *ngIf="items">
  <div class="scroll-sidebar">
    <nav class="sidebar-nav">
      <ul id="sidebarnav">
        <li *ngFor="let item of items" [id]="item.id">
          <a class="waves-effect waves-dark" [routerLink]="item.url" aria-expanded="false">
            <i class="fa-fw" [class]="item.icon"></i>
            <span class="hide-menu">{{ item.label }}</span>
          </a>
        </li>
        <!-- <li class="signin-as-sidebar" (click)="openSiginAsModal()" *ngIf="currentUser.type === 0">
          <a class="waves-effect waves-dark" aria-expanded="false">
            <i class="fa-fw" class="fad fa-pencil"></i><span class="hide-menu">Entrar como</span>
          </a>
        </li> -->
      </ul>
    </nav>
  </div>
</aside>
